module.exports = __webpack_public_path__ + "img/ecg.942ef291.png";